import Slideshow from "./components/Slideshow";
import Navbar from "./components/Navbar";
import Services from "./components/Services";
import Footer from "./components/Footer";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <Navbar />
      <Slideshow />
      <Services />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
